import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import TypeformLogo from "../../common/logo";
import { useMenuContext } from "../mega-menu-provider";
import { jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo(props) {
  var _useMenuContext = useMenuContext(),
    isMenuScrolled = _useMenuContext.isMenuScrolled;
  return /*#__PURE__*/_jsx(TypeformLogo, _objectSpread(_objectSpread({
    "data-testid": "static-logo"
  }, props), {}, {
    animated: true,
    hideType: isMenuScrolled
  }));
};
export default Logo;